import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class EvaluationObjective extends BaseService {
  constructor() {
    super("evaluation-objectives");
  }

  /**
   *
   * @param {string} assignedEmployee
   * @param {string} enterpriseId
   * @param {{criterias?: string[]}} params
   * @returns
   */
  getByEmployee(assignedEmployee, enterpriseId, params = { criterias: [] }) {
    params.criterias = JSON.stringify(params.criterias);
    return getResponseQuery(
      http.get(
        `${this.path}/get-by-employee/${assignedEmployee}/${enterpriseId}`,
        { params }
      )
    );
  }

  getByEvaluationCriteria(evaluationCriteriaId, assignedEmployee) {
    return getResponseQuery(
      http.get(
        `${this.path}/get-by-evaluation-criteria/${evaluationCriteriaId}/${assignedEmployee}`
      )
    );
  }

  /**
   * @param {string} assignedEmployee
   * @param {string} enterpriseId
   * @returns
   */
  getWithNotation(assignedEmployee, enterpriseId) {
    return getResponseQuery(
      http.get(
        `${this.path}/get-with-notation/${assignedEmployee}/${enterpriseId}`
      )
    );
  }
}

export default new EvaluationObjective();
